import { IAyhContract } from '@public/service/ports';
import request, { ISettings } from '@common/axios/requestUtil';
import { IAES } from '@common/utils/EAS';
export interface IUserSmInfo {
  ident: string;
  aesName: string;
  aesMobile: string;
  aesTime: string;
  userId: number;
  isIdcardExpired: string;
  studentFlag: '0' | '1' | null;
  appleBindFlag: 0 | 1;
  uniqueId: string; //这个是啥类型还不清楚
  hasChecked: 0 | 1;
  hasTransPwd: 0 | 1;
  loginType: number;
  mobile: string;
  refusePeriod: '0' | '1';
  hasAccts: boolean;
  increaseCreditType: string;
}
export const getContractInfo = async (data = {}): Promise<IResponse | null> => {
  const url = `/vayhapi/vayh/cashflow/V1.0/hasContract`;
  // todo: normalPost -> post, 需要测试 by allen
  const result = await request.post(url, data, {
    ignoreErrorCode: true,
  });
  return result;
};

export const getUserSmInfo = async (data = {}, options?: ISettings): Promise<IUserSmInfo> => {
  const url = `/vayhapi/vayh/my/V1.0/aes/profileforhidden`;
  const result = await request.post(url, data, options);
  return result?.result;
};

export const getLoanMsgInfo = async (data = {}): Promise<any> => {
  const url = `/vayhapi/vayh/my/V1.0/loanmsg`;
  const result = await request.post(url, data);
  return result?.result;
};

export interface IAddContactOptions {
  tempApplyNo: string; // 一个流水号
  monthIncomeRange: string; // 月收入，但是为什么加1了？？
  contact: Array<{ aesName: string; aesMobile: string }>;
  empPost: string; // 收入
}

export const addContactsMethod = async (params: IAddContactOptions): Promise<any> => {
  const url = `/vayhapi/vayh/cashflow/V1.0/bindContactsOptimize`;
  const result = await request.post(url, params);
  return result?.result;
};

export const getUserSignInfo = async (): Promise<any> => {
  // 这里应该是repay得接口
  const result = await request.post('/acr/pay/paySign/V1/query', {});

  return result?.result;
};

export const getUserSignInfoData = async (params = {}, options = {}): Promise<any> => {
  // 这里应该是repay得接口
  const result = await request.post('/acr/pay/paySign/V1/query', params, options);

  return result;
};
/**
 * 查询用户支付宝签约状态
 * @param data
 * @returns
 */
export const getUserZFBSignInfo = async (data = {}): Promise<any> => {
  const result = await request.post('/pub/pay/paySigns/V1/query', data);
  return result?.result;
};

export interface IGetRsaMyCardsOptions {
  hasZdSign?: boolean | string;
  isAuth?: string;
}

/**
 * 查询是否可以更改用户姓名
 * @param data
 * @returns
 */
export const submitRealNameAuth = async (params = {}, options = {}): Promise<any> => {
  const url = `/pcr/creditApply/authRealName/V1/submit`;
  const result = await request.post(url, params, options);
  return result;
};

/***
 *  获取我得银行卡列表， 不包含微信和支付宝
 *
 * */
export const getRsaMyCards = async (params: IGetRsaMyCardsOptions, aes: IAES): Promise<any> => {
  const url = `/vayhapi/vayh/bank/V1.0/rsa/mycards`;
  const result = await request.post(url, params, {
    aes,
  });
  return result?.result;
};

/***
 *  获取我的银行卡列表-小贷需求新增
 *
 * */
export const getRsaMyCardsForth = async (params: any, options?: ISettings): Promise<any> => {
  const result: IResponse<any> | null = await request.post(
    '/vayhapi/vayh/bank/V4.0/rsa/mycards',
    params,
    options,
  );
  return result?.result;
};

/**
 * 查询用户是否有助贷卡，这个本来是node 发的。参数不明
 * @param params
 */
export const accountHasPlatCard = async (params: any): Promise<any> => {
  const url = `/vayhapi/vayh/my/V1.0/hasPlatformCard`;
  const result = await request.post(url, params);
  return result?.result;
};

/**
 * 查询是否可以更改用户姓名
 * @param data
 * @returns
 */
export const hasSupport = async (data = {}): Promise<any> => {
  const url = `/vayhapi/vayh/my/V1.0/modifyName/hasSupport`;
  const result = await request.post(url, data);
  return result?.result;
};

export const qetUserBehavior = async (data = {}): Promise<any> => {
  const url = `/pub/user/behavior/V1/query`;
  const result = await request.post(url, data);
  return result?.result;
};

export const setUserBehavior = async (data = {}): Promise<any> => {
  const url = `/pub/user/behavior/V1/submit`;
  const result = await request.post(url, data);
  return result?.result;
};

export const hasSupportModifyName = async (data = {}): Promise<any> => {
  const url = `/vayhapi/vayh/my/V1.0/modifyName/hasSupport`;
  const result = await request.post(url, data, { ignoreErrorCode: true });
  return result;
};

export const submitOpenTicket = async (data = {}, options?: ISettings): Promise<any> => {
  const url = `/pub/user/behavior/V1/submit`;
  const result = await request.post(url, data, options);
  return result;
};

export interface IGetRsaMyCardsOptions {
  hasZdSign?: boolean | string;
  isAuth?: string;
}

/***
 *  获取我得银行卡列表-新（630需求增加，新增了主体列表contractSourceInfoList内容）， 不包含微信和支付宝
 *
 * */
export const getRsaMyCardsNext = async (params: IGetRsaMyCardsOptions, aes: IAES): Promise<any> => {
  const url = `/vayhapi/vayh/bank/V2.0/rsa/mycards`;
  const result = await request.post(url, params, {
    aes,
  });
  return result?.result;
};

export async function fetchLoanMsg(params?: any): Promise<any> {
  const result = await request.post('/icr/view/contract/cashLoan/V1/query', params);
  return result?.result || {};
}

// 上传身份证照片
export const cashOcrQuality = async (params, options?): Promise<any> => {
  const result = await request.post('/vayhapi/vayh/cashflow/V1.0/cashOcrQuality', params, options);
  return result;
};
